var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGastric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00038 16.2302C2.97038 13.9202 4.7404 12.0002 7.0204 11.8702H7.1504C8.8404 11.7602 10.4004 12.7702 11.0204 14.3602C11.1704 14.7402 11.5104 15.0002 11.9104 15.0402C12.5404 15.1002 13.0804 14.6002 13.0804 13.9702L13.0604 8.91017C13.0604 6.90017 14.5504 5.20017 16.5304 4.97017C19.1604 4.67017 21.4104 6.84017 21.2504 9.50017L21.1604 10.9802C20.9704 14.0202 19.4904 16.8202 17.0904 18.6802C14.9104 20.3802 12.1604 19.8602 9.81037 18.3202C9.81037 18.3202 8.09039 16.6402 7.80039 16.3902C7.59039 16.2002 6.89038 16.2302 6.88038 16.3802C6.83038 16.8502 6.86038 15.6302 6.75038 17.6402C6.58038 20.5402 6.78038 20.5102 6.60038 20.5102C3.93038 20.5102 6.55038 20.5702 3.82038 20.4602H3.72038C3.72038 20.4602 3.02039 17.1602 3.01039 16.2502L3.00038 16.2302Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 4.94043C10.4004 4.94043 11.2404 6.40043 12.5804 7.25043",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8203 3C12.8203 3 13.6603 4.46 15.0003 5.31",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.541 12.1001L14.411 11.7001C15.181 11.3401 16.081 11.4401 16.761 11.9601L17.391 12.4401C18.291 13.1301 19.521 13.0801 20.371 12.3301L20.971 11.8001",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastric);
export default __webpack_public_path__ + "static/media/Gastric.dc4e9d51482b517812b6f738eafb1a75.svg";
export { ForwardRef as ReactComponent };